module.exports = __webpack_public_path__ + "img/SYC.5944ad39.svg";